module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_stills_pet_500_ksg.f9cc5204.png";